import { LightBulbIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';

const NoPickems = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <h2 className="mb-3 font-semibold text-2xl text-white">Your Picks</h2>

      <span className="text-center text-gray text-md">
        After you make some picks they will appear here.
      </span>

      <div className="flex flex-col items-center justify-evenly">
        <Image
          alt="no picks"
          height={265}
          src={'/assets/no_picks.png'}
          width={302}
        />

        <div className="rounded-lg bg-dark-gray p-4">
          <div className="mb-2 flex items-center gap-2">
            <LightBulbIcon className="h-6 w-6 text-blue-gray" />
            <span className="font-medium">TIP</span>
          </div>

          <span className="font-medium text-sm text-white">
            Playing all picks isn’t required, but it still brings extra points
            if you guess them correctly.
          </span>
        </div>
      </div>
    </div>
  );
};

export default NoPickems;
